import { Action } from "common/types";

import { actionTypes } from "./actions";
import { ModuleState } from "./types";

export const initialiseState = (): ModuleState => ({
  attempting: null
});

export default function reducer(
  state: ModuleState,
  action: Action<string>
): ModuleState {
  switch (action.type) {
    case actionTypes.setAttemptingWord: {
      return { ...state, attempting: action.payload };
    }

    default: {
      throw new Error(
        `Grid module-state reducer, action type ${action.type} not recognised`
      );
    }
  }
}
